import React, { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "../services/api";
import { DashboardHeader } from "./DashboardHeader";
import DashboardContent from "./DashboardContent";
import DashboardFooter from "./DashboardFooter";
import "./DashboardWidgets/index.css";
import "./Dashboard.css";

export const Dashboard: React.FC = () => {
  const [selectedTenantId, setSelectedTenantId] = useState<string>("");
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    queryClient.invalidateQueries({ queryKey: ["devices"] });
    queryClient.invalidateQueries({ queryKey: ["tenants"] });
  };

  useEffect(() => {
    const unsubscribe = api.subscribeEvents(() => {
      queryClient.invalidateQueries({ queryKey: ["devices"] });
    });
    return () => unsubscribe();
  }, [queryClient]);

  return (
    <div className="dashboard">
      <DashboardHeader
        selectedTenantId={selectedTenantId}
        onSelectTenant={(id) => setSelectedTenantId(id)}
        onRefresh={handleRefresh}
      />
      <DashboardContent selectedTenantId={selectedTenantId} />
      <DashboardFooter />
    </div>
  );
};

export default Dashboard;